module.exports = __webpack_public_path__ + "img/building2.e1ae9500.jpg";